import { render, staticRenderFns } from "./KRadioButton.vue?vue&type=template&id=5fb1645e&scoped=true&"
import script from "./KRadioButton.vue?vue&type=script&lang=js&"
export * from "./KRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./KRadioButton.vue?vue&type=style&index=0&id=5fb1645e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1645e",
  null
  
)

export default component.exports